export default {
      id: "check-deposit-usage",
      viewBox: "-5 0 32 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#check-deposit",
      toString: function () {
        return this.url;
      }
    }